export default __webpack_public_path__ + "static/media/enghien26.8d72fdb2.jpg";